// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import color from 'color';

type Props = {
  gutterBottom?: boolean,
  gutterTop?: boolean,
  kind: 'success' | 'info' | 'danger' | 'warning',
  children: any
};

const Wrapper = styled.div(({ gutterBottom, gutterTop, kind, theme }) => ({
  background: color(theme.color[kind])
    .mix(color('white'), 0.9)
    .string(),
  borderColor: `${theme.color[kind]}`,
  color: theme.color[kind],
  padding: theme.spacing.small,
  borderRadius: theme.spacing.xsmall,
  fontSize: theme.fontSize.medium,
  marginBottom: gutterBottom ? theme.spacing.small : 0,
  marginTop: gutterTop ? theme.spacing.small : 0,
  '& > a': {
    color: theme.color[kind]
  }
}));

const Message = ({ gutterTop, gutterBottom, kind, children }: Props) => (
  <Wrapper gutterBottom={gutterBottom} gutterTop={gutterTop} kind={kind}>
    {children}
  </Wrapper>
);

Message.defaultProps = {
  gutterBottom: true,
  gutterTop: false
};

export default React.memo(Message);
